'use client';

import { ReactNode, useEffect, useLayoutEffect, useState } from 'react';

const useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

const NoSsr = (props: { children: ReactNode; defer?: boolean; fallback?: ReactNode }) => {
  const { children, defer = false, fallback = null } = props;
  const [mountedState, setMountedState] = useState(false);

  useEnhancedEffect(() => {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);

  useEffect(() => {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]);

  return mountedState ? children : fallback;
};

export default NoSsr;
